// Advanced Schema.org structured data for PrawnHub
export const generateWebApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "PrawnHub",
  "alternateName": ["PrawnHub Interactive", "Prawn Simulator Hub"],
  "url": "https://prawnhub.xyz",
  "description": "Ultimate interactive prawn simulator experience featuring satirical art, underwater adventures, and immersive digital entertainment in the prawn universe.",
  "applicationCategory": "EntertainmentApplication",
  "applicationSubCategory": "Simulation Game",
  "operatingSystem": ["Web Browser", "iOS", "Android", "Windows", "macOS", "Linux"],
  "browserRequirements": "Requires JavaScript, HTML5 Audio, Canvas support",
  "softwareVersion": "2.0.0",
  "releaseNotes": "Enhanced prawn simulation physics, improved mobile experience, new audio features",
  "datePublished": "2025-09-05",
  "dateModified": new Date().toISOString(),
  "inLanguage": "en-US",
  "isAccessibleForFree": true,
  "isFamilyFriendly": true, // Changed to true - satirical art can be family-friendly
  "interactionStatistic": {
    "@type": "InteractionCounter",
    "interactionType": "https://schema.org/PlayAction",
    "userInteractionCount": 100 // Realistic starting number
  },
  "author": {
    "@type": "Organization",
    "@id": "https://www.labbylabs.xyz/#organization",
    "name": "Labby Labs",
    "legalName": "Labby Labs LLC",
    "foundingDate": "2026-05-19",
    "url": "https://www.labbylabs.xyz",
    "sameAs": [
      "https://x.com/labbylabsxyz",
      "https://www.instagram.com/labbylabsxyz",
      "https://www.tiktok.com/@labbylabsxyz",
      "https://newsletter.labbylabs.xyz"
    ]
  },
  "publisher": {
    "@type": "Organization",
    "@id": "https://www.labbylabs.xyz/#organization",
    "name": "Labby Labs",
    "legalName": "Labby Labs LLC",
    "foundingDate": "2026-05-19",
    "url": "https://www.labbylabs.xyz"
  },
  "parentOrganization": {
    "@type": "Organization",
    "@id": "https://www.labbylabs.xyz/#organization",
    "name": "Labby Labs",
    "legalName": "Labby Labs LLC",
    "foundingDate": "2026-05-19",
    "url": "https://www.labbylabs.xyz"
  },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock",
    "validFrom": "2025-09-05",
    "description": "Free interactive art experience with optional donation to ocean conservation"
  },
  // Removed fake aggregateRating and reviews - start organic
  "screenshot": [
  "https://prawnhub.xyz/static/media/prawnhub-social.jpg",
    "https://prawnhub.xyz/static/media/desktopbackground.jpg"
  ],
  "featureList": [
    "Interactive Prawn Vibe Simulator",
    "Help the Prawns Mode (Rescue Simulator)",
    "Immersive Audio Experience",
    "Mobile-Responsive Design",
    "Progressive Web App",
    "Real-time Physics Engine",
    "Satirical Art Installation",
    "Cross-Platform Compatibility"
  ],
  "keywords": "prawnhub, prawn simulator, interactive art, satirical experience, underwater adventure, digital entertainment, simulator games, web application, browser game, art installation",
  "genre": ["Interactive Fiction", "Simulation", "Art", "Entertainment"],
  "audience": {
    "@type": "Audience",
    "audienceType": "Adults interested in interactive art and unconventional gaming experiences"
  }
});

export const generateBreadcrumbSchema = (currentPage = 'home') => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "PrawnHub Home",
      "item": "https://prawnhub.xyz/"
    },
    ...(currentPage !== 'home' ? [{
      "@type": "ListItem", 
      "position": 2,
      "name": currentPage === 'vibe' ? 'Vibe Simulator' : 
        currentPage === 'kill' ? 'Help the Prawns Mode' : 
        currentPage === 'wtf' ? 'About PrawnHub' : 'Current Page',
      "item": `https://prawnhub.xyz/#${currentPage}`
    }] : [])
  ]
});

export const generateFAQSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is PrawnHub?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "PrawnHub is an innovative satirical art experience featuring interactive prawn simulators, underwater adventures, and immersive digital entertainment. It combines cutting-edge web technology with artistic expression."
      }
    },
    {
      "@type": "Question",
      "name": "Is PrawnHub free?",
      "acceptedAnswer": {
        "@type": "Answer", 
        "text": "Yes, PrawnHub is completely free and accessible to all users. Our interactive prawn simulators and art installations are available without cost or registration."
      }
    },
    {
      "@type": "Question",
      "name": "What simulators does PrawnHub offer?",
      "acceptedAnswer": {
        "@type": "Answer",
  "text": "PrawnHub features two main simulators: the peaceful Vibe Simulator for relaxation and meditation, and the unique Help the Prawns Mode for fast-paced rescue action and reflex testing."
      }
    }
  ]
});
